<template>
  <div>
    <!-- <MapModal
      :modalNode="modalNode"
      :title="program.title"
      :id="program.id"
      :close="videoSurveilClick"
      v-show="0"
    >
    </MapModal> -->

    <MapModal
      :modalNode="editModalNode"
      :submitData="editSubmitData"
      :title="editProgram.title"
      :id="editProgram.id"
      :close="editProgramClose"
      :submit="editSubmit"
      v-show="editToggle"
    >
    </MapModal>
    <!-- 添加/编辑 -->
    <ChangeInformation
      :changState="changState"
      :itemTreeData="itemTreeData"
      :programToggle.sync="programToggle"
      :menuData="menuData"
      :bimVector="bimVector"
    ></ChangeInformation>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import { treeDataJson } from "./static-data.js";
import ChangeInformation from "@/components/tables/program/ChangeInformation";
import { getProjectSettings, getBimPlanDetail } from "@/api/api";
export default {
  name: "program",
  components: { MapModal, ChangeInformation },
  props: {
    menuData: {
      type: Array,
    },
    bimVector: {
      type: Boolean,
    },
  },
  data() {
    return {
      // 假数据
      // treeDataJson: {},
      // graphicLayer: [],
      programToggle: false,
      changState: "",
      itemTreeData: null,
      program: {
        title: "方案",
        id: "program", // id和ref使用的同一个
      },
      modalNode: {
        program: {
          show: true, // 默认展示
          loading: true, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -376,
            // unit: "px", // 默认px
          },
          // width: "450px", // 宽度配置 默认450px
          height: "350px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "bimVideoCategoryTree", // id和ref使用的同一个
            name: "text", // 树的展示字段 默认name
            i_icon: {
              level_1: "el-icon-tickets",
            },
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            search: {
              //不需要搜索直接不传
              // type: "", //暂时无用 预留字段 后期配置 判断是否是ajax
              keywords: "text", // 搜素配置关键字 默认是name
              // filterNode: this.filterNode, // 搜索的逻辑 可以自己配置
            },
            // nodeClick 事件绑定
            nodeClick: this.nodeClick,
          },
          //模态框foot配置
          foot: {
            addProgram: {
              type: "button",
              buttonType: "primary",
              i_icon: "el-icon-zengjia",
              title: "新增方案",
              disabled: false,
              click: this.addProgram,
            },
          },
        },
      },
      // 编辑模态框
      editSubmitIndex: null,
      editToggle: false,
      editProgram: {
        title: "添加",
        id: "editProgram", // id和ref使用的同一个
      },
      editModalNode: {
        editProgram: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -706,
            // unit: "px", // 默认px
          },
          // width: "450px",
          // auto 自适应
          height: "auto",
          //模态框head配置
          head: {},
          //模态框中心配置
          content: {
            type: "form",
            formData: {
              name: {
                md: 24,
                type: "input",
                title: "方案名称",
                placeholder: "请输入",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "请填写文本",
                  trigger: "blur",
                },
              ],
            },
          },
        },
      },
      editSubmitData: {
        name: null,
      },
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    // 自定义方法
    toggleFold(item, state) {
      item.state = state;
    },
    // 节点被点击时的回调
    nodeClick(data) {
      console.log("节点被点击时的回调");
      console.log(data);
    },
    videoSurveilClick() {
      console.log("老方法 触发关闭");
      if (this.$GLOBAL.markDrawGraphicLayer) {
        this.$GLOBAL.markDrawGraphicLayer.clear();
      }
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      this.$emit("videoSurveilBox_close");
    },
    // 添加
    addProgram(item) {
      console.log(item);
      this.editProgram.title = "新增";
      this.editSubmitIndex = null;
      this.editToggle = true;
      this.editSubmitData.name = "";
    },
    // 编辑
    handleEdit(item) {
      console.log(item);
      this.changState = "edit";
      this.itemTreeData = item;
      this.programToggle = true;
      this.editToggle = false;
    },
    // 开始更改名称
    handleEditName(item, node) {
      console.log(node);
      this.editSubmitIndex = node;
      this.editProgram.title = "编辑";
      this.itemTreeData = item;
      this.editToggle = true;
      this.editSubmitData.name = this.itemTreeData.text;
    },
    editSubmit() {
      if (this.editSubmitIndex != null) {
        this.editSubmitIndex.data.text = this.editSubmitData.name;
        this.$notify({
          title: "修改成功",
          message: "",
          type: "success",
          duration: 960,
          offset: 320,
        });
      } else {
        this.modalNode.program.content.treeDataJson.push({
          id: "new",
          text: this.editSubmitData.name,
          operate: [
            {
              i_icon: "small-operation-btn el-icon-edit",
              click: this.handleEdit,
            },
            {
              i_icon: "small-operation-btn el-icon-video-play",
              click: this.handlePlay,
            },
            {
              i_icon: "las la-signature",
              click: this.handleEditName,
            },
            {
              i_icon: "small-operation-btn el-icon-delete",
              click: this.handleDelete,
            },
          ],
        });
        this.itemTreeData = {
          id: "new",
          text: this.editSubmitData.name,
        };
        this.programToggle = true;
        this.editToggle = false;
        this.$notify({
          title: "添加成功",
          message: "",
          type: "success",
          duration: 960,
          offset: 320,
        });
      }
    },
    // 删除
    handleDelete(item) {
      this.$confirm("确定删除该方案吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(item);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    // 播放
    handlePlay(item) {
      console.log(item);
    },
    // 处理json数据
    unpackData(data) {
      data.forEach((item) => {
        item.operate = [
          //操作按钮
          {
            i_icon: "small-operation-btn el-icon-edit",
            click: this.handleEdit,
          },
          {
            i_icon: "small-operation-btn el-icon-video-play",
            click: this.handlePlay,
          },
          {
            i_icon: "las la-signature",
            click: this.handleEditName,
          },
          {
            i_icon: "small-operation-btn el-icon-delete",
            click: this.handleDelete,
          },
        ];
      });
      this.modalNode.program.loading = false;
      return data;
    },

    editProgramClose() {
      this.editToggle = false;
    },
    // 初始化
    init() {
      this.modalNode.program.content.treeDataJson =
        this.unpackData(treeDataJson);
      getBimPlanDetail({
        Id: this.$route.params.scenarioGroupId,
      }).then((res) => {
        this.handleEdit(res.data.data);
      });
    },
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
    this.init();
  },
  watch: {},
  destroyed() {},
};
</script>
